<template>
  <!-- PROCESS CONTENT -->
  <v-navigation-drawer
    :value="drawer"
    absolute
    class="qmkey-process-map-drawer"
    :class="drawer ? 'qmkey-drawer-open' : 'qmkey-drawer-close'"
    width="fit-content"
  >        
    <ProcessData
      v-if="true"
      ref="data"
      :process="process"
      :roles="roles"
      :departments="departments"
      container_class="qmkey-process-tabs-items"
      @refresh="refresh"
    />
    
  </v-navigation-drawer>
</template>

<style lang="scss">
 .qmkey-drawer-open{
    width: fit-content;
    min-width: 40%;
    max-width: 40%;
  }
  .qmkey-drawer-close{
    width: 0px !important;
  }
  .qmkey-process-map-drawer{
    z-index: 2;
    background-color: white;
    overflow: hidden auto;
    height: 100%;
  }
  .qmkey-permission-title {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .qmkey-process-tabs-items {
    height: 100%;
    padding: 1vh;
    width: 100vh; 
  }
  .qmkey-process-data {
    display: flex;
    flex-direction: column;
  }
  .qmkey-process-data-actions {
    display: flex;
    justify-content: flex-end;
  }
  .qmkey-process-permition-list {
    text-wrap: wrap;
    overflow-wrap: break-word;
    white-space: wrap;
    min-inline-size: 100px;
    max-inline-size: 250px;
  }
  .qmkey-process-add-permission {
    display: flex;
    justify-content: center;
  }
</style>

<script>
  import ProcessData from '@/components/process/ProcessData'
  export default {
    name: 'ProcessesDataOrgChart',

    components: {
      ProcessData,
    },


    props: {
      drawer: {default: false},
      process: {},
      roles: {},
      departments: {},
    },
    
    data: () => ({
      confirmation_dialog: false,
      modal_title: 'Are you sure?',
    }),

    computed: {
    },

    methods: {

      refresh() {
        this.$emit('refresh');
      },
    },
  }
</script>